<template lang="pug">
  #welcome.container.xs-f-small.max-at-tweak
    component(:is="customerComponent")

</template>

<script>
  import { mapState } from "vuex";
  import PageSkeleton from "@components/PageSkeleton";
  import { defineAsyncComponent } from "vue";

  export default {
    name: "Welcome",

    components: {
      ReturnCustomer: defineAsyncComponent({ loader: () => import('./ReturnCustomer'), loadingComponent: PageSkeleton }),
      ReturnVisitor: defineAsyncComponent({ loader: () => import('./ReturnVisitor'), loadingComponent: PageSkeleton }),
    },

    computed: {
      ...mapState('customer', ['cdata']),

      customerHasAppointments() {
        return Boolean((this.cdata.pastServices || []).length) || Boolean((this.cdata.futureServices || []).length);
      },

      customerHasFlaggedOrders() {
        return Boolean((this.cdata.pendingOrders || []).length);
      },

      customerComponent() {
        let dashboardType = this.cdata.visitorType.toLowerCase() !== 'return buyer' ? 'ReturnVisitor' : 'ReturnCustomer';

        /* Edge case 1 - a user whose order was flagged with "needs review" */
        // Orders which are flagged with "needs review" are not considered during calculation for cData.visitorType,
        // On the dashboard level, however, we consider any user who has made an order to be a "returning customer", and should be
        // chauffeured to the returning customer dashboard where the review orders page lives

        // Edge case 2 - a user who has an upcoming or past appointment also should see RCD
        if (this.customerHasAppointments || this.customerHasFlaggedOrders) {
          dashboardType = 'ReturnCustomer';
        }

        return dashboardType;
      }
    },
  };
</script>
